import { ScreenReadersOnly, Stack } from '@customink/pigment-react';
import { useCallback, useState } from 'react';
import { BraintreeProvider } from '~/adapters/braintree/context';
import { ErrorBoundary } from '~/components/ErrorBoundary';
import { usePage } from '~/adapters/browser/usePage';
import { Title } from '~/pages/Settings/title';
import { HostedFieldDialog } from './HostedFieldDialog';
import { PaymentCardList } from './PaymentCardList';
import { HostedFieldsProvider } from './HostedFieldsContext';

export function PaymentMethodsTab() {
    const [dialogOpen, setDialogOpen] = useState(false);
    // const openDialog = useCallback(() => {
    //     setDialogOpen(true);
    //     sendVaultedPaymentsEvent('Add Card');
    // }, []);
    const closeDialog = useCallback(() => setDialogOpen(false), []);

    usePage({ title: Title, reportPath: '/accounts/payment_methods' });

    return (
        <ErrorBoundary>
            <BraintreeProvider>
                <Stack gap={4}>
                    <ScreenReadersOnly>
                        <h2>Payment Methods</h2>
                    </ScreenReadersOnly>
                    {/* Temp hide this page because of brute force https://customink.slack.com/archives/GTFAS3SE7/p1707380124697179 */}
                    {/* <Box sx={{ display: 'flex', justifyContent: 'right' }}> */}
                    {/*     <Button onClick={openDialog} variant="secondary"> */}
                    {/*         Add Card */}
                    {/*     </Button> */}
                    {/* </Box> */}
                    <PaymentCardList />
                </Stack>
                <HostedFieldsProvider onCardAdd={closeDialog}>
                    <HostedFieldDialog open={dialogOpen} closeDialog={closeDialog} />
                </HostedFieldsProvider>
            </BraintreeProvider>
        </ErrorBoundary>
    );
}
